import React, { useState, useEffect, useContext } from "react";
import { create } from "../../../Api/WebApi";
import logo from "../../../Assets/Images/logo.png";
import search from "../../../Assets/Images/search.png";
import cart from "../../../Assets/Images/cart.png";
import tab1 from "../../../Assets/Images/tab1.png";
import myaccount from "../../../Assets/Images/myaccount.png";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Menu, Dropdown } from "antd";
import LoginPopup from "../Login/LoginPopup";
import WebHomeProvider from "../../../Provider/WebHomeProvider";
import {
  PoweroffOutlined,
  DeliveredProcedureOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  SearchOutlined,
  WalletFilled,
  // UserOutlined,
} from "@ant-design/icons";
import WebMyAccountProvider from "../../../Provider/WebMyAccountProvider";
import CartContext from "../../../Provider/CartProvider";
import MobileMenu from "./MobileMenu";
import CartDrawer from "./CartDrawer";
import ProductSearch from "./ProductSearch";
import { useLocation } from "react-router-dom";
const Header = ({ productMenuList }) => {
  const { webLoginPopup, setWebLoginPopup, cartDrawer, setCartDrawer } =
    useContext(WebMyAccountProvider);
  const { productSearchPopup, setProductSearchPopup } =
    useContext(WebHomeProvider);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const { cartList, getCartList } = useContext(CartContext);
  const [isScrolled, setIsScrolled] = useState(false);
  const [menu, setMenu] = useState([]);
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  console.log(query);

useEffect(() => {
  const getUserDetails = async () => {
    try {
      const res = await create("myaccount.php?action=getlogincheck");
      if (res?.status === 200 && res?.success === true) {

        if (res && res.data) {
            setIsLoggedIn(true);
          }else{
            setIsLoggedIn(false); 
          }
      } else {
        setIsLoggedIn(false); 
      }
    } catch (err) {
      console.log(err);
    setIsLoggedIn(false); 
    }
  };
  getUserDetails();
}, []);
  // useEffect(() => {
  //   const source = query.get("utm_source");
  //   const medium = query.get("utm_medium");
  //   const campaign = query.get("utm_campaign");
  //   source !== null && sessionStorage.setItem("utm_source", source || "");
  //   medium !== null && sessionStorage.setItem("utm_medium", medium || "");
  //   campaign !== null && sessionStorage.setItem("utm_campaign", campaign || "");
  // }, [query]);


  const deleteSessionOverview = async (sessionId) => {
    try {
      const res = await create("cart.php?action=deletesess", {
        session_id: sessionId
      });

      if (res?.status === 200 && res?.success === true) {
        console.log("Session added successfully.");
      } else {
        console.error("Failed to add session.");
      }
    } catch (err) {
      console.error("Error in adding session:", err);
    }
  };  
  
  useEffect(() => {
    const source = query.get("utm_source");
    const medium = query.get("utm_medium");
    const campaign = query.get("utm_campaign");

    const expirationTime = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
    const currentTime = new Date().getTime();

    if (source !== null) {
      sessionStorage.setItem(
        "utm_source",
        JSON.stringify({ value: source || "", timestamp: currentTime })
      );
    }
    if (medium !== null) {
      sessionStorage.setItem(
        "utm_medium",
        JSON.stringify({ value: medium || "", timestamp: currentTime })
      );
    }
    if (campaign !== null) {
      sessionStorage.setItem(
        "utm_campaign",
        JSON.stringify({ value: campaign || "", timestamp: currentTime })
      );
    }

    const cleanup = () => {
      const checkAndRemove = (key) => {
        const item = sessionStorage.getItem(key);
        if (item) {
          const { value, timestamp } = JSON.parse(item);
          if (currentTime - timestamp > expirationTime) {
            sessionStorage.removeItem(key);
          }
        }
      };

      checkAndRemove("utm_source");
      checkAndRemove("utm_medium");
      checkAndRemove("utm_campaign");
      checkAndRemove("customer_session");
    };
    cleanup();

    let customer_session = localStorage.getItem('customer_session');
    console.log(customer_session);
    if(customer_session ===null){
       customer_session = Math.random().toString(36).substr(1, 12);
     localStorage.setItem(
        "customer_session",
        JSON.stringify({ value: customer_session || "", timestamp: currentTime })
      );
    }

    const clearSess = () => {
      const delSess = (key) => {
        const item = localStorage.getItem(key);
        if (item) {
          const { value, timestamp } = JSON.parse(item);
          if (currentTime - timestamp > expirationTime) {
            localStorage.removeItem(key);
            if (key === "customer_session") {
            deleteSessionOverview(value);
          }
          }
        }
      };
      delSess("customer_session");
    };
    clearSess();
  }, [query]);

  useEffect(() => {
    getCartList();
 
  const addSessionOverview = async (sessionId,channel) => {
    try {
      const res = await create("cart.php?action=createsession", {
        session_id: sessionId,
        refer_channel: channel,
      });

      if (res?.status === 200 && res?.success === true) {
        console.log("Session added successfully.");
      } else {
        console.error("Failed to add session.");
      }
    } catch (err) {
      console.error("Error in adding session:", err);
    }
  };


const storedSession = localStorage.getItem("customer_session");
const channelSource = sessionStorage.getItem("utm_source");

let parsedSession = null;
let parsedChannel = null;

if (storedSession) {
  try {
    parsedSession = JSON.parse(storedSession);
  } catch (e) {
    console.error("Error parsing customer_session:", e);
  }
}

if (channelSource) {
  try {
    parsedChannel = JSON.parse(channelSource);
  } catch (e) {
    console.error("Error parsing utm_source:", e);
  }
}

if (parsedSession?.value) {
  addSessionOverview(parsedSession.value, parsedChannel?.value || null);
} else {
  console.warn("Stored session or session value is missing.");
}


  menuFunction(null, menu_list);
  }, [productMenuList]);

  const menu_list = [
    {
      id: 1,
      url: "./",
      name: "Home",
      parent: null,
    },
    {
      id: 2,
      url: "/products",
      name: "Products",
      parent: null,
    },
    {
      id: 3,
      url: "/blog",
      name: "Blog",
      parent: null,
    },
    {
      id: 4,
      url: "/bulk-enquiry",
      name: "Bulk Enquiry",
      parent: null,
    },
    ...productMenuList?.map((e) => {
      return {
        id: e?.value,
        url: "/product/" + e?.slug,
        name: e?.label,
        parent: 2,
      };
    }),
    // {
    //   id: 5,
    //   url: "/shop",
    //   name: "Our Story",
    //   parent: 1,
    // },
  ];
  const menuFunction = (parent, menu) => {
    const filter = menu?.filter((e) => {
      return String(e.parent) === String(parent);
    });
    const final = filter?.map((e) => {
      return {
        key: e?.id,
        label: <Link to={e.url === "" ? void 0 : e.url}>{e.name}</Link>,
        children:
          menuFunction(e.id, menu).length > 0 ? menuFunction(e.id, menu) : "",
      };
    });
    setMenu(final);
    return final;
  };
  const logout = () => {
    localStorage.removeItem("nattu_customer_login");
    localStorage.removeItem("nattu_customer_token");
    window.location.href = "/";
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const items = [
    {
      label: <Link to="/myaccount/profile">My Profile</Link>,
      key: "1",
      icon: <UserOutlined />,
    },
    {
      label: <Link to="/myaccount/orders">My Orders</Link>,
      key: "2",
      icon: <ShoppingCartOutlined />,
    },
    {
      label: <Link to="/myaccount/orders">Track Order</Link>,
      key: "2a",
      icon: <DeliveredProcedureOutlined />,
    },
    {
      label: <div onClick={logout}>Logout</div>,
      key: "3",
      icon: <PoweroffOutlined />,
    },
  ];

  return (
    <HeaderSection>
      <LoginPopup />
      <div className={isScrolled ? "scrolled header_bottom" : "header_top"}>
        <div className="wrapper">
          <div class="marquee-container">
            <p class="marquee">
              Why pay for delivery? Get FREE shipping across India on all your
              favorite items. Shop now!{" "}
            </p>
          </div>
        </div>
      </div>
      <div className={"header_bottom"}>
        <div className="wrapper">
          <div className="header_align">
            <div className="header_left">
              <Link to="/" title="Naatu Sakkarai">
                <img src={logo} alt="Naatu Sakkarai" />
              </Link>
            </div>
            <div className="header_center">
              <Menu mode="horizontal" items={menu} />
            </div>
            <div className="header_right">
              <div className="header_right_align">
                <div className="header_right_align_item">
                  {/* <div>
                    <img src={search} alt="" />
                  </div> */}
                  <SearchOutlined
                    onClick={() => setProductSearchPopup(!productSearchPopup)}
                  />
                  <div className="mob_hide">
                    {isLoggedIn ? (
                      <Dropdown
                        menu={{
                          items,
                        }}
                        placement="bottomRight"
                      >
                        <a
                          onClick={(e) => e.preventDefault()}
                          href={void 0}
                          className="profile"
                        >
                          {/* <img src={myaccount} alt="" /> */}
                          <UserOutlined />
                        </a>
                      </Dropdown>

                    ) : (
                      <img
                        src={myaccount}
                        alt=""
                        onClick={() => setWebLoginPopup(!webLoginPopup)}
                      />
                    )}
                  </div>
{/*                  <div className="mob_hide">
                  {isLoggedIn ? (
                    <WalletFilled/>
                    ):('')}
                  </div>*/}
                  <div className="mob_only">
                    <Link
                      to={void 0}
                      title="Cart"
                      onClick={() => setCartDrawer(!cartDrawer)}
                    >
                      <div className="mob_cart">
                        <img src={tab1} alt="" />
                        <span>{cartList?.items?.length || 0}</span>
                      </div>
                    </Link>
                    <MobileMenu items={menu} />
                    {/* <img src={tab3} alt="" /> */}
                  </div>
                </div>
                {/* <div className="header_search">
                  <input name="search" placeholder="Search Products.." />
                </div> */}

                <div className="header_cart_button">
                  <Link
                    to={void 0}
                    title="Cart"
                    onClick={() => setCartDrawer(!cartDrawer)}
                  >
                    <button>Cart ({cartList?.items?.length || 0})</button>
                  </Link>
                </div>
                {/* <div className="my_Account">
                  <button type="button"></button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CartDrawer />
      <ProductSearch />
    </HeaderSection>
  );
};

export default Header;

const HeaderSection = styled.section`
  position: sticky;
  top: 0;
  z-index: 111;
  background: #fff;
  display: grid;
  width: 100%;
  box-shadow: 0 0 6px rgb(0 0 0 / 10%);
  .scrolled {
    height: 0;
    opacity: 0;
    transition: all 0.5s ease;
    padding: 0 !important;
    width: 100%;
    /* position: fixed !important;
    top: 0;
    z-index: 80;
    background: #fff;
    left: 0;
    box-shadow: 0 0 6px rgb(0 0 0 / 10%); */
  }
  .scrolled p {
    opacity: 0 !important;
  }
  .marquee-container {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
  }

  .marquee {
    display: inline-block;
    padding-left: 100%;
    width: 100%;
    animation: marquee 20s linear infinite;
  }

  @keyframes marquee {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-100%);
    }
  }
  .scrolled .header_align {
    padding: 10px 0 !important;
  }
  .header_top {
    /* position: sticky; */
    top: 0;
    width: 100%;
    display: inline-block;
    /* position: relative; */
    padding: 10px 0;
    background: #fcdc2a;
    transition: all 0.5s ease;
  }
  .header_top p {
    text-align: center;
    color: var(--black);
    font-size: 14;
    font-family: var(--medium);
  }
  .header_bottom {
    display: inline-block;
    position: relative;
    width: 100%;
  }
  .header_align {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 14px 0;
    width: 100%;
  }
  .header_left {
    display: inline-block;
    position: relative;
    width: fit-content;
  }
  .header_left img {
    height: 70px;
  }
  .header_right {
    display: inline-block;
    width: fit-content;
  }
  .header_right_align {
    display: flex;
    flex-direction: row;
    gap: 22px;
    align-items: center;
  }
  .header_right_align_item {
    display: flex;
    align-items: center;
    gap: 23px;
  }
  .header_right_align img {
    height: 22px;
  }
  .header_search input {
    padding: 13px 20px;
    height: 43px;
    border: 0;
    border-radius: 35px;
    width: 247px;
    background: #f3f3f3 url(${search});
    background-repeat: no-repeat;
    background-size: 17px;
    outline: none;
    background-position: center right 20px;
  }
  .header_search input::placeholder {
    color: #e1e1e1;
  }
  .header_cart_button button {
    height: 43px;
    background: #181818 url(${cart}) no-repeat;
    border: 0;
    border-radius: 35px;
    outline: none;
    padding: 10px 20px;
    color: #fff;
    padding-left: 45px;
    background-size: 17px;
    background-position: center left 20px;
  }
  .my_Account button {
    height: 43px;
    width: 43px;
    border-radius: 100%;
    background: #d9d9d9 url(${myaccount}) no-repeat;
    background-position: center;
    border: 0;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: transparent;
    background-size: 18px;
  }
  .header_right_align_item img {
    cursor: pointer;
  }
  .header_center {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 550px;
    min-height: 50px;
  }
  .header_center .ant-menu-light,
  .header_center .ant-menu-light > .ant-menu {
    width: 550px;
    margin: auto;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
  .mob_only {
    display: none;
  }
  .mob_cart {
    display: flex;
    position: relative;
    width: fit-content;
    margin: auto;
  }
  .mob_cart span {
    display: flex;
    height: 17px;
    width: 17px;
    position: absolute;
    background: var(--theme_color);
    top: -5px;
    right: -12px;
    color: #fff;
    font-size: 10px;
    font-family: var(--semibold);
    border-radius: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
  .header_right_align svg {
    font-size: 25px;
  }
  @media screen and (max-width: 1200px) {
    .header_center {
      display: none;
    }
    .mob_only {
      display: flex;
      align-items: center;
      gap: 30px;
    }
    .header_cart_button {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    .header_top {
      display: none;
    }
    .marquee {
      animation: inherit;
    }
    .scrolled {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    .header_cart_button {
      display: none;
    }
    /* .header_right_align_item div:nth-child(2) {
      display: none;
    } */
  }

  @media screen and (max-width: 576px) {
    position: sticky;
    top: 0;
    z-index: 11;
    background: #fff;
    box-shadow: 0 0 6px rgb(0 0 0 / 10%);

    .header_left img {
      height: 55px;
    }
    .header_align {
      padding: 12px 0;
    }
    .header_cart_button button {
      height: 40px;
      padding: 10px 15px;
      padding-left: 35px;
      font-size: 13px;
      background-position: center left 12px;
    }
    .header_right_align {
      gap: 20px;
    }
  }

  @media screen and (max-width: 480px) {
    .header_top {
      display: none;
    }
    .scrolled {
      display: none;
    }
  }
`;
